import * as qs from 'qs';
import { useLayoutEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { IMPACT_PAGE_LOAD_API_URL } from '#src/config.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { idFromObject } from '#src/gql/idFromObject.ts';
import { useAbsoluteURL } from '#src/hooks/useAbsoluteURL.ts';
import { localStorage } from '#src/lib/storage/localStorage.ts';
import { randomUUID } from '#src/lib/uuid.ts';

const IMPACT_CAMPAIGN_ID = 12209;

export const ResolveImpactClickId = () => {
  const [searchParams] = useSearchParams();
  const { currentUser } = useCurrentUserContext() || {};

  const location = useLocation();
  const href = useAbsoluteURL(location, { stripBaseName: true });

  useLayoutEffect(() => {
    if (!IMPACT_PAGE_LOAD_API_URL) {
      // env not configured
      return;
    }

    if (
      searchParams.get('irclickid') ||
      !searchParams.get('utm_campaign')?.match(/^[0-9]+$/)
    ) {
      // only calls Impact if there is a utm_campaign that looks like a MediaPartnerID and no clickid,
      return;
    }

    if (!localStorage.getItem('CUSTOM_PROFILE_ID')) {
      localStorage.setItem('CUSTOM_PROFILE_ID', randomUUID());
    }

    fetch(IMPACT_PAGE_LOAD_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: qs.stringify({
        CampaignId: IMPACT_CAMPAIGN_ID,
        PageUrl: href,
        ReferringUrl: document.referrer,
        EventDate: 'NOW',
        CustomProfileId: localStorage.getItem('CUSTOM_PROFILE_ID'),
        ...(currentUser?.id && {
          CustomerId: idFromObject(currentUser.id),
          CustomerEmail: '',
        }),
      }),
    })
      .then(async response => {
        if (response.ok) {
          const json = await response.json();
          if (json.clickId) {
            localStorage.setItem('IMPACT_CLICKID', json.clickId);
          }
        }
      })
      .catch(() => {
        /* ignore */
      });
  }, [currentUser?.id, searchParams, href]);

  return null;
};
